import { TW_DateCell, TW_DateCell_editing } from "@utils/twClasses";
import { displayDate, isoDateRegex } from "@utils/types";
import { useEffect, useState } from "react";
import { useModelStore, useUserStore } from "src/store";
import { AbstractCell } from "./AbstractCell";
import { CellProps } from "./GridCell";
import { Item } from "@dto/records";
import { useTranslation } from "react-i18next";
import { EditRightAccess, ObjectRightType } from "@dto/Users";
import { hasGlobalRightAccess, ViewRightType } from "@dto/Users";


export function DateCell({ pathKey, field, item, position, updateValue, isEditing, inputRef, blurTriggered }: CellProps) {

    const userRole = useModelStore(state => state.userRole);
    const user = useUserStore(state => state.user);
    const selectedObjectInfos = useModelStore(state => state.selectedObjectInfos);
    const selectedView = useModelStore(state => state.selectedView);
    const hasEditAccessOnObject = hasGlobalRightAccess(user, userRole, ObjectRightType, EditRightAccess, selectedObjectInfos?.object?._key);
    const hasEditAccessOnView = hasGlobalRightAccess(user, userRole, ViewRightType, EditRightAccess, selectedView?._key);
    const hasEditAccess = hasEditAccessOnObject && hasEditAccessOnView;
    const readOnly = item.readOnly || !hasEditAccess ;

    const [text, setText] = useState(item ? item.value || "" : "");
    const lang = useUserStore(state => state.lang);
    const wsColor = useModelStore(state => state.wsColor);
    const { t } = useTranslation();
    const [lastBlurTriggered, setLastBlurTriggered] = useState<number | null>(null);
    const format = selectedView?.formats?.get(pathKey ?? "") ?? field?.format;

    useEffect(() => {
        if (item?.value !== text) {
            setText(item ? item.value || "" : "");
        }
    }, [item]);

    useEffect(() => {
        const newValue = textToValue(text);
        if (isEditing && lastBlurTriggered && blurTriggered && lastBlurTriggered !== blurTriggered && item?.value !== newValue) {
            updateValue(item, newValue);
        }
        setLastBlurTriggered(blurTriggered);
    }, [blurTriggered]);

    const updateLocalValue = (item: Item, value: any) => {
        setText(value || "");
        updateValue(item, value);
    }

    const textToValue = (text: string | null): any => {
        if (!text || text.length === 0) {
            return null;
        }
        if (isoDateRegex.test(text)) {
            return text;
        }
        return null;
    }

    const valueToText = (): string => {
        return displayDate(text, format, field.aggregation, t);
    }

    function isTextValid(value: string | null) {
        if (!value || value.length === 0) {
            return true;
        }
        return true;
    }

    const renderReadOnlyContent = () => {
        return (
            <div className={TW_DateCell + (readOnly ? " cursor-not-allowed" : "")}>
                {valueToText()}
            </div>
        )
    }

    const renderEditingContent = (
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        onEnterKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void,
        inputRef: React.RefObject<HTMLInputElement>,
    ) => {
        return (<>
            <input
                className={TW_DateCell_editing}
                type="date"
                lang={lang}
                value={text}
                onKeyDown={onEnterKeyPress}
                onChange={onTextChange}
                autoFocus={true}
                style={{ borderColor: wsColor }}
                ref={inputRef}
            />
        </>)
    }

    const updateText = (text: string | null) => {
        setText(text);
        // updateValue(item, text);
    }

    return <AbstractCell
        item={item}
        position={position}
        updateValue={updateLocalValue}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        text={text}
        setText={updateText}
        isEditing={isEditing}
        inputRef={inputRef}
        readOnly={readOnly}
    />
}
